export default {
  'en-US': {
    orderStatuses: {
      None: 'None',
      Pending: 'Pending',
      Processing: 'Processing',
      Completed: 'Shipped',
      Exception: 'Exception',
      OnHold: 'On Hold',
      Cancelled: 'Cancelled',
      CleanSweeped: 'Clean Sweeped',
      LabeledCreated: 'Processing',
      ImportReview: 'Import Review'
    }
  },
  'ja-JP': {
    orderStatuses: {
      None: '無し',
      Pending: '保留中',
      Processing: '処理',
      Completed: '完了しました',
      Exception: '例外',
      OnHold: '保留',
      Cancelled: 'キャンセル',
      CleanSweeped: 'クリーンスウィープ',
      LabeledCreated: 'ラベル付き',
      ImportReview: 'インポートレビュー'
    }
  }
}
